import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { useThemeMode } from '../../hooks/useThemeMode';
import { MOBILE_TABS, NAV_ITEMS } from './nav';
import { cn } from '../../lib/cn';

const GLYPHS: Record<string, string> = {
  Dashboard: '▦', Risks: '▲', Tasks: '☑',
  Reports: '▤', Contacts: '☷', Organizations: '☰', Settings: '⚙',
};

export const MobileTabBar: React.FC = () => {
  const [moreOpen, setMoreOpen] = useState(false);
  const navigate = useNavigate();
  const { logout } = useAuth();
  const { mode, setMode } = useThemeMode();
  const primary = NAV_ITEMS.filter((n) => (MOBILE_TABS as readonly string[]).includes(n.label));
  const rest = NAV_ITEMS.filter((n) => !(MOBILE_TABS as readonly string[]).includes(n.label));
  const nextMode = mode === 'light' ? 'dark' : mode === 'dark' ? 'system' : 'light';

  return (
    <>
      <nav className="fixed inset-x-0 bottom-0 z-[1300] flex border-t border-ink bg-paper md:hidden"
        data-testid="mobile-tabbar" data-print-hide>
        {primary.map((n) => (
          <NavLink key={n.path} to={n.path} data-testid={`tab-${n.label.toLowerCase()}`}
            className={({ isActive }) =>
              cn(
                '-mt-px flex min-h-12 flex-1 flex-col items-center justify-center gap-0.5 border-t-2 border-transparent py-1.5 text-ink-muted',
                isActive && 'border-accent text-accent'
              )
            }>
            <span className="text-scale-3">{GLYPHS[n.label]}</span>
            <span className="cap-label !text-[9px]">{n.label}</span>
          </NavLink>
        ))}
        <button type="button" data-testid="tab-more" onClick={() => setMoreOpen(true)}
          className="-mt-px flex min-h-12 flex-1 flex-col items-center justify-center gap-0.5 border-t-2 border-transparent py-1.5 text-ink-muted">
          <span className="text-scale-3">⋯</span>
          <span className="cap-label !text-[9px]">More</span>
        </button>
      </nav>

      {moreOpen && (
        <div className="fixed inset-0 z-[1350] bg-ink/30 md:hidden" onClick={() => setMoreOpen(false)}>
          <div className="absolute inset-x-0 bottom-0 border-t border-ink bg-paper p-4 pb-16"
            onClick={(e) => e.stopPropagation()}>
            {rest.map((n) => (
              <button key={n.path} type="button" data-testid={`tab-more-${n.label.toLowerCase()}`}
                onClick={() => { setMoreOpen(false); navigate(n.path); }}
                className="flex w-full items-center gap-3 border-b border-rule-faint py-3 text-left font-sans text-scale-2 text-ink">
                <span>{GLYPHS[n.label]}</span>{n.label}
              </button>
            ))}
            <div className="mt-3 flex justify-between">
              <button type="button" onClick={() => setMode(nextMode)}
                className="cap-label" data-testid="tab-more-theme">◐ Theme: {mode}</button>
              <button type="button" onClick={() => logout()}
                className="cap-label text-accent" data-testid="tab-more-logout">Sign out</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
